import { useEffect, useState } from 'react'
import { isPlus, getUser } from '../lib/user'
import { startCheckout, awaitEntitlement, type Plan } from '../lib/billing'
import { friendly } from '../lib/errors'
import { TopBar } from './TopBar'
import { BottomNav } from './BottomNav'

const FEATURES = [
  ['✦', 'Extended packs', '5 more questions on the daily theme, every day'],
  ['🎲', 'Unlimited practice', 'A fresh random 5, whenever you want'],
  ['📊', 'Stats Pro', 'Your accuracy by category, bias, and trend'],
  ['🧊', 'Streak freeze', 'One missed day a month forgiven'],
  ['📦', 'Category packs', 'Space, Money, the Body… (coming soon)'],
]

export function Plus() {
  const [busy, setBusy] = useState(false)
  const [note, setNote] = useState('')
  const [, force] = useState(0)
  useEffect(() => {
    if (location.href.includes('checkout=success')) {
      setNote('Payment received — activating Plus…')
      awaitEntitlement().then((ok) => { setNote(ok ? 'Way Off Plus is live ✦' : 'Taking longer than usual — it will appear shortly.'); force((x) => x + 1) })
    } else if (location.href.includes('checkout=cancelled')) setNote('Checkout cancelled — no charge.')
  }, [])
  const buy = (plan: Plan) => async () => {
    setBusy(true)
    try {
      if (getUser()?.isAnonymous) { location.hash = '#/account'; return } // save progress first so Plus survives the device
      await startCheckout(plan)
    } catch (e) { setNote(friendly(e)); setBusy(false) }
  }
  return (
    <div className="screen">
      <TopBar />
      <h1 style={{ fontSize: 32, margin: '18px 0 4px' }}>Way Off <span style={{ color: 'var(--pop)' }}>Plus</span></h1>
      <p className="muted" style={{ margin: 0 }}>The daily game stays free, forever. Plus is for people who want more.</p>
      <ul className="qlist" style={{ marginTop: 16 }}>
        {FEATURES.map(([em, t, d]) => <li key={t}><span className="em">{em}</span><span><div><b>{t}</b></div><div className="p">{d}</div></span><span /></li>)}
      </ul>
      <div className="actions">
        {isPlus()
          ? <a className="btn block" href="#/practice">You have Plus — go practise 🎲</a>
          : <>
            <button className="btn block" disabled={busy} onClick={buy('monthly')}>{busy ? 'Opening checkout…' : 'Get Plus — £1.49/month'}</button>
            <button className="btn ghost block" disabled={busy} onClick={buy('lifetime')}>Lifetime — £19.99, one payment, forever</button>
          </>}
        {note && <p className="tiny center">{note}</p>}
        <a className="btn ghost block" href="#/">Back to today</a>
      </div>
      <BottomNav />
    </div>
  )
}
